import React from 'react';
import classnames from 'classnames';
import { Link } from '@latitude/link';
import { Heading5 } from '@latitude/heading';
import { ALIGN, COLOR, MARGIN } from '@latitude/core/utils/constants';
import './_card-icon.scss';
const component = 'card-icon';
const Heading = props => {
  const config = {};
  if (!props.url) {
    config.dangerouslySetInnerHTML = {
      __html: props.title
    };
  } else {
    config.children = /*#__PURE__*/React.createElement(Link, {
      href: props.url,
      noStyle: true
    }, props.title);
  }
  const allowed = ['h4', 'h5'];
  return !allowed.includes(props.element) ? null : /*#__PURE__*/React.createElement(props.element, Object.assign({
    className: classnames(`${component}__title`, 'mt-0', 'mb-3', props.titleClass)
  }, config));
};
const CardIcon = _ref => {
  let {
    children,
    className,
    contained,
    cta,
    leftAligned,
    image,
    small,
    thumbnail,
    title,
    titleUrl,
    titleClass,
    row,
    rowMobile,
    style,
    newBrand
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(component, 'd-flex', leftAligned && `${component}--left-aligned`,
    // TODO: this variant has been depracated. Remove after all pages containing it have been redesigned.
    contained && `${component}--contained`, thumbnail && `${component}--thumbnail`, small && `${component}--small`, row ? `${component}--row` : 'flex-column', rowMobile && `${component}--row-mobile`, className),
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(`${component}__image`)
  }, image), newBrand ? /*#__PURE__*/React.createElement(Heading5, {
    align: ALIGN.CENTER,
    color: COLOR.BLACK,
    marginBottom: MARGIN.M8
  }, title) : /*#__PURE__*/React.createElement(Heading, {
    element: small ? 'h5' : 'h4',
    title: title,
    url: titleUrl,
    titleClass: titleClass
  }), children && /*#__PURE__*/React.createElement("div", {
    className: `${component}__content`
  }, children), cta && /*#__PURE__*/React.createElement("div", {
    className: classnames(`${component}__cta`, 'pt-3', 'mt-auto')
  }, cta));
};
export default CardIcon;